/* global $ */
import Scrollbar from 'smooth-scrollbar';

const $modules = $.$body.find('[data-module],.module');
const $loadmap = $.$body.find('.map__list__item');
// add class to last module
$modules.last().addClass('last-module');

let timeOutId = null;

const el = document.querySelector('.map__list');
let scrollbar;
if (el) {
	scrollbar = Scrollbar.init(el);
}
$loadmap.each(function () {
	const $mapa = $(this).attr('id');
	$('.state#' + $mapa).addClass('active');
});

// Accordions
$.$body
	.on('focus', '.module__accordion .js-accordion-button', (e) => {
		$(e.currentTarget).attr('aria-selected', true);
	})
	.on('blur', '.module__accordion .js-accordion-button', (e) => {
		$(e.currentTarget).attr('aria-selected', false);
	})
	.on('click', '.module__accordion .js-accordion-button', (e) => {
		e.preventDefault();

		// console.log('accordion open');

		const $button = $(e.currentTarget);
		const isExpanded = $button.attr('aria-expanded') === 'true';
		const $header = $button.closest('.accordion__headline');
		const $section = $header.next('.accordion__content');

		$button.attr('aria-expanded', !isExpanded);
		$section.attr('aria-hidden', isExpanded);

		if (!isExpanded) {
			const $rowAnchor = $header.closest('.accordion__single-row');
			window.scrollTo(0, $rowAnchor.offset().top - 95);
			clearTimeout(timeOutId);
			timeOutId = setTimeout(() => {
				$section.addClass('js-accordion-fully-open');
			}, 500); // makes sure if the content is really long, it's eventually all opened up
			// if (false && 'scrollIntoViewIfNeeded' in $rowAnchor.get(0)) {
			//   $rowAnchor.get(0).scrollIntoViewIfNeeded(false);
			// } else if (false && 'scrollIntoView' in $rowAnchor.get(0)) {
			//   $rowAnchor.get(0).scrollIntoView(true);
			// } else {
			//   window.scrollTo(0, $rowAnchor.offset().top - 95);
			// }
		} else {
			$section.removeClass('js-accordion-fully-open');
			clearTimeout(timeOutId);
		}
	})

	.on('click', '.map__list__item__top', (e) => {
		e.preventDefault();
		const $this = $(e.currentTarget);
		const $description = $this.parent();
		setStateActive($description.attr('id'), true);
		if (!$description.find('.map__list__item__bottom').hasClass('open')) {
			$('.map__list__item.active')
				.removeClass('active')
				.find('.map__list__item__bottom')
				.hide()
				.removeClass('open');
		} else {
			$('.map__list__item.active')
				.removeClass('active')
				.find('.map__list__item__bottom')
				.hide()
				.removeClass('open');
			$('.state').removeClass('selected');
		}
	});

$.$body.on('click', '.state', (e) => {
	e.preventDefault();
	const $state = $(e.currentTarget).attr('id');
	setStateActive($state);
});

const setStateActive = ($state) => {
	if (!$('#' + $state).hasClass('selected')) {
		$('.map__list__item__bottom').hide();
		$('.state').removeClass('selected');
		$('#' + $state).addClass('selected');
		const item = $('.map__list__item#' + $state);

		if (item.length) {
			scrollbar.scrollTo(0, item.position().top, 600, {
				callback: () => {
					item.siblings().removeClass('active');
					item.addClass('active')
						.find('.map__list__item__bottom')
						.slideDown();
				},
			});
			if (item.is(':last-child')) {
				setTimeout(function () {
					scrollbar.update();
					scrollbar.scrollTo(0, item.position().top + 400, 600);
				}, 1000);
			}
		}
	} else {
		$('#' + $state).removeClass('selected');
		$('.map__list__item.active')
			.removeClass('active')
			.find('.map__list__item__bottom')
			.hide()
			.removeClass('open');
	}
};

$('.state.active')
	.mouseover(function () {
		const $stateid = $(this).attr('id');
		const $statelabel = $stateid.replace('-', ' ');
		$('.map-hover .text').html($statelabel).parent().show();
	})
	.mouseout(function () {
		$('.map-hover .text').html('').parent().hide();
	});

document.addEventListener('mousemove', (e) =>
	$('.map-hover').css({ left: e.clientX, top: e.clientY })
);
